import api from './api';

const getHomeService = ({ carModel }: { carModel: string }) =>
  api.get(`service-booking/v1/home-service/home-services?carModel=${carModel}`);

const getWorkshopService = ({ carModel }: { carModel: string }) =>
  api.get(`service-booking/v1/layanan-bengkel/workshop-service?carModel=${carModel}`);

const getVehicleMaster = ({ carModel }: { carModel?: string }) => {
  if (carModel) return api.get(`service-booking/v1/vehicles/vehicle-master?modelName=${carModel}`);
  else return api.get(`service-booking/v1/vehicles/vehicle-master`);
};

const getHomeServiceSlots = (payload) => {
  return api.post('service-booking/v1/home-service/home-service-slots', null, payload);
};

export default { getHomeService, getVehicleMaster, getHomeServiceSlots, getWorkshopService };
